/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Is_HiddenInputs */

const en_tables_custom_properties_is_hidden = /** @type {(inputs: Tables_Custom_Properties_Is_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Is Hidden`)
};

const de_tables_custom_properties_is_hidden = /** @type {(inputs: Tables_Custom_Properties_Is_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ausgeblendet`)
};

/**
* | output |
* | --- |
* | "Properties Is Hidden" |
*
* @param {Tables_Custom_Properties_Is_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_is_hidden = /** @type {((inputs?: Tables_Custom_Properties_Is_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Is_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_is_hidden(inputs)
	return de_tables_custom_properties_is_hidden(inputs)
});